import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-edit-limit',
		path: '/dashboard/petitions/:slug/edit_limit',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_edit_limit" */ './index'), {
			exportName: 'AdminEditLimit',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
